import tinycolor from 'tinycolor2'

/* eslint-disable no-bitwise,no-plusplus */
const stringToHash = str => {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
    hash &= hash
  }

  return hash
}

// Converts the hash to a random HEX string
export const hexColorFromString = str => {
  if (str.length === 0) {
    return '#ffffff'
  }

  const hash = stringToHash(str)
  let color = '#'
  let value = 0

  for (let i = 0; i < 3; i++) {
    value = (hash >> (i * 8)) & 255
    color += (`00${value.toString(16)}`).substr(-2)
  }

  return color
}

const range = (hash, min, max) => {
  const diff = max - min
  const x = ((hash % diff) + diff) % diff

  return x + min
}

export const hslColorFromString = str => {
  const result = { h: 0, s: 100, l: 30 }

  if (str.length === 0) {
    return result
  }

  const hash = stringToHash(str)

  return {
    h: range(hash, 0, 360),
    s: 80,
    l: 50
  }
}
/* eslint-enable no-bitwise,no-plusplus */

export const rgbaColorFromHex = (hex, alpha) => {
  const rgbColor = tinycolor(hex).toRgb()

  return `rgba(${rgbColor.red}, ${rgbColor.green}, ${rgbColor.blue}, ${alpha})`
}

const LIGHT_MODE_MAX_BRIGHTNESS = 229
const DARK_MODE_MIN_BRIGHTNESS = 45
const DARK_MODE_FORBIDDEN_COLOR = '#1a1a1a'

export const normalizeChartColor = (color, { darkMode = false } = {}) => {
  const parsedColor = tinycolor(color)

  if (!parsedColor.isValid()) {
    return color
  }

  let adjustedColor = parsedColor
  let attempts = 0

  if (darkMode) {
    while (
      (
        adjustedColor.toHexString() === DARK_MODE_FORBIDDEN_COLOR
        || adjustedColor.getBrightness() < DARK_MODE_MIN_BRIGHTNESS
      )
      && attempts < 12
    ) {
      adjustedColor = tinycolor.mix(adjustedColor, '#ffffff', 12)
      attempts += 1
    }
  } else {
    while (adjustedColor.getBrightness() > LIGHT_MODE_MAX_BRIGHTNESS && attempts < 12) {
      adjustedColor = tinycolor.mix(adjustedColor, '#000000', 12)
      attempts += 1
    }
  }

  if (!attempts) {
    return color
  }

  return adjustedColor.toHexString()
}
